import { useTranslation } from "react-i18next"
import { Loader2 } from "lucide-react"
import { Button } from "@/components/ui/button"

interface LoadMoreButtonProps {
  hasMore: boolean
  isLoading: boolean
  onClick: () => void
}

export function LoadMoreButton({ hasMore, isLoading, onClick }: LoadMoreButtonProps) {
  const { t } = useTranslation()

  if (!hasMore) return null

  return (
    <div className="flex justify-center py-2">
      <Button
        variant="ghost"
        size="sm"
        onClick={onClick}
        disabled={isLoading}
        className="text-primary"
      >
        {isLoading ? (
          <>
            <Loader2 size={14} className="animate-spin" />
            <span className="ml-1.5">{t("common.loading")}</span>
          </>
        ) : (
          t("common.loadMore")
        )}
      </Button>
    </div>
  )
}
